"use strict";


const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const typography = require("!!css-loader!../../tokens/typography.css").default;

class Element extends HTMLElement {


    constructor(template) {
        super();

        this.root = this.attachShadow({ mode: "closed" });

        /**
         * Applying styles inside the shadow DOM:
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM#applying_styles_inside_the_shadow_dom
         */
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(typography);
        this.root.adoptedStyleSheets = [sheet];

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.container = this.root.querySelector(".swiftref-badge");

    }



    connectedCallback() {
        if (this.innerHTML) {
            this.container.innerText = this.innerHTML;
            // if the content is a text, uses different border-radius
            if (isNaN(this.container.innerText)) {
                this.container.classList.add("text");
                this.container.classList.add("caption");
            } else {
                // number has custom font
                this.container.classList.add("caption-b");

            }
        }

        this.innerHTML = "";
    }

}

window.customElements.define("swiftref-badge", Element);

module.exports = Element;
